<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h3 style="display: flex; align-items: center; gap: 8px">
          <i class="ph ph-envelope-simple" style="font-size: x-large"></i>
          Send WA Notification
        </h3>
      </div>
      <div class="card-body">
        <div v-loading="emailConfigLoading" :element-loading-text="loadingText">
          <div
            style="
              padding: 10px;
              max-height: 250px;
              overflow-y: scroll;
              overflow-x: hidden;
              scrollbar-width: thin;
            "
          >
            <!-- <div v-if="checkBulkSendCondition()">
            Filter
            <el-select
              v-model="entityNotificationBody.filter_id"
              clearable
              placeholder="Select saved filter"
              style="width: 97.5%; margin-bottom: 10px"
            >
              <el-option
                v-for="filter in selectedNotifyEntityFilters"
                :key="filter._id"
                :label="filter.filter_name"
                :value="filter._id"
                >{{ filter.filter_name }}</el-option
              >
            </el-select>
          </div> -->
            <el-row class="email-options">
              <div>
                <el-radio-group v-model="event_code" size="small">
                  <el-radio-button label="WA_CLOUD">Cloud API</el-radio-button>
                  <el-radio-button label="WA_WEB">WA WEB</el-radio-button>
                </el-radio-group>
              </div>
              <div>
                <a
                  @click="chooseFromWhatsappTemplates"
                  class="pop-up-button"
                  style="margin-left: 300px"
                >
                  Choose from whatsapp templates
                </a>
              </div>
            </el-row>

            <br />
            <div>
              <div>
                <el-row>
                  <el-select
                    v-model="email_fields.wa_accountId"
                    placeholder="Choose Sender account"
                    size="small"
                    style="width: 50%"
                    clearable
                    remote
                    @change="validateSenderAccount"
                    class="email-field"
                  >
                    <el-option
                      v-for="(wa, i) in getWAaccountsByEvent()"
                      :key="wa + i"
                      :value="wa._id"
                      :label="wa.name"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    v-model="email_fields.entity_fields"
                    placeholder="Receiver phone number"
                    size="small"
                    clearable
                    filterable
                    multiple
                    remote
                    style="width: 50%"
                    default-first-option
                    class="email-field"
                    collapse-tags
                  >
                    <el-option
                      v-for="(field, i) in contactFields"
                      :key="field + i"
                      :value="field.template_key"
                      :label="field.label"
                    >
                    </el-option>
                  </el-select>
                </el-row>
                <br />
                <el-row>
                  <el-select
                    v-model="email_fields.custom_emails"
                    placeholder="Custom phone number"
                    size="small"
                    class="email-field"
                    multiple
                    clearable
                    style="width: 50%"
                    filterable
                    collapse-tags
                    default-first-option
                    allow-create
                  >
                    <el-option
                      v-for="item in email_fields && email_fields.custom_emails"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="email_fields.filters"
                    clearable
                    multiple
                    class="email-field"
                    placeholder="Select relational entity"
                    size="small"
                    style="width: 50%"
                    default-first-option
                  >
                    <el-option
                      value="CONTACTS"
                      label="Contacts"
                      v-if="
                        currentEntity && currentEntity.entity_type == 'BUSINESS'
                      "
                    >
                    </el-option>
                    <el-option
                      value="SELF"
                      label="Self"
                      v-if="
                        currentEntity &&
                        currentEntity.entity_type == 'INDIVIDUAL'
                      "
                    >
                    </el-option>
                    <el-option
                      v-for="field in getEntityFields(allFields)"
                      :key="field.key"
                      :label="'Field - ' + field.label"
                      :value="'FIELD#' + field.key"
                    >
                    </el-option>
                    <el-option
                      v-for="relation in selectedEntityRelationships"
                      :key="relation._id"
                      :label="relation.entity_name"
                      :value="'RELATION#' + relation._id"
                      >{{ relation.entity_name }} ({{
                        relation.relationship_title
                      }})
                    </el-option>
                  </el-select>
                </el-row>
                <br />
              </div>
            </div>
            <div style="margin-top: 15px">
              <el-row>
                <el-col :span="12">
                  <span style="font-weight: 400">Message body</span>
                </el-col>
              </el-row>
              <div
                v-loading="ckeditorLoading"
                :element-loading-text="loadingText"
                style="margin-top: 10px"
              >
                <ckeditor
                  v-if="isOpened"
                  v-model="entityNotificationBody.body"
                  :config="editorConfig"
                  :key="editorKey"
                ></ckeditor>
              </div>
            </div>
            <div class="parent-template-class">
              <div class="attachments-footer">
                <el-row style="margin-top: 10px">
                  <el-col :span="24">
                    <div
                      class="attachments"
                      v-if="
                        currentEntity && currentEntity.default_printing_document
                      "
                    >
                      <el-checkbox v-model="sendDataAsAttachment"
                        >Send Data as an attachment</el-checkbox
                      >
                    </div>
                    <div class="d-flex" v-if="sendDataAsAttachment">
                      <div style="margin-right: 5px">
                        Printing name
                        <el-input
                          v-model="sendDataAsAttachmentName"
                          placeholder="File name"
                        ></el-input>
                      </div>
                      <div>
                        Select document template
                        <el-select
                          v-model="sendDataAsAttachmentDocument"
                          placeholder="Select Documents"
                          default-first-option
                          size="medium"
                          style="width: 90%"
                          filterable
                        >
                          <el-option
                            v-for="(doc, i) in entityDocuments"
                            :key="i + '_document'"
                            :label="doc.title"
                            :value="doc.configurable_document_id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="attachments">
                      <el-checkbox v-model="hasAttachment"
                        >Attach Documents ?</el-checkbox
                      >
                    </div>
                    <div class="attachments"></div>
                    <div
                      v-if="hasAttachment"
                      style="
                        display: flex;
                        justify-content: center;
                        margin-top: 10px;
                      "
                    >
                      <el-upload
                        class="upload-demo"
                        name="logo"
                        :on-change="uploadFile"
                        action
                        :show-file-list="false"
                        :auto-upload="false"
                        :limit="10"
                        accept=".doc, .pdf, .docx, .txt, .png, .jpg, .jpeg, .xls, .xlsx, .xlsm,"
                        multiple
                        :file-list="files"
                      >
                        <el-button
                          size="medium"
                          type="primary"
                          class="document"
                          style="margin: auto"
                          >Click to upload</el-button
                        >
                      </el-upload>
                      <el-select
                        v-model="selectedDocuments"
                        placeholder="Select Documents"
                        class="document"
                        size="medium"
                        multiple
                        clearable
                        filterable
                        collapse-tags
                      >
                        <el-option
                          v-for="(field, i) in docFields"
                          :key="field + i"
                          :value="field.template_key"
                          :label="field.label"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </el-col>
                </el-row>
                <el-row v-if="hasAttachment">
                  <p>
                    Supported file formats:.doc, .pdf, .docx, .txt, .png, .jpg,
                    .jpeg, .xls, .xlsx, .xlsm
                  </p>
                  <p>Maximum upload file size: 10 MB</p>
                </el-row>
                <el-row v-if="hasAttachment" style="margin-top: 10px">
                  <el-col :span="24" class="name-types">
                    <div
                      v-if="files && files.length"
                      style="text-align: center"
                    >
                      <h4>Uploaded Documents :</h4>
                    </div>
                    <div
                      class="filename"
                      v-for="(file, index) in files"
                      :key="JSON.stringify(file)"
                      style="display: flex; justify-content: center"
                    >
                      <a class="el-upload-list__item-name">
                        <img
                          :src="require('@/assets/img/icons/upload-active.svg')"
                          alt="icon"
                          class="img-active"
                        />
                        <img
                          v-if="
                            file.type == 'image/jpeg' ||
                            file.type == 'image/jpg'
                          "
                          :src="require('@/assets/img/icons/JPG.svg')"
                          alt="icon"
                          class="img-fluid"
                        />
                        <img
                          v-else-if="file.type == 'image/png'"
                          :src="require('@/assets/img/icons/PNG.svg')"
                          alt="icon"
                          class="img-fluid"
                        />
                        <img
                          v-else-if="file.type == 'image/png'"
                          :src="require('@/assets/img/icons/PNG.svg')"
                          alt="icon"
                          class="img-fluid"
                        />

                        <img
                          v-else
                          :src="require('@/assets/img/icons/pdf.svg')"
                          alt="icon"
                          class="img-fluid"
                        />
                        {{
                          file.name.includes(".") && file.name.split(".")[0]
                            ? file.name.split(".")[0].includes("_")
                              ? file.name.split(".")[0]
                              : file.name.split(".")[0] &&
                                file.name.split(".")[0].replaceAll("_", " ")
                            : file.name && file.name.replaceAll("_", " ")
                        }}
                        <a @click="deleteItem(index)">
                          <i class="el-icon-circle-close"></i>
                        </a>
                      </a>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer text-muted d-flex justify-end">
        <p slot="footer">
          <el-button
            type="primary"
            v-loading="emailConfigLoading"
            :disabled="checkIsDisabled()"
            @click="sendNotification"
            class="mr-4"
            >{{ isAutomation ? "Save" : "Send" }}
            <i v-if="!isAutomation" class="el-icon-s-promotion"></i
          ></el-button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { ckEditorConfig } from "@/assets/data/ckeditor_config.ts";

import { mapGetters } from "vuex";
import axios from "@/config/axios";
import AutomationHelper from "@/mixins/AutomationHelper";
import { validateInstance } from "../../Configuration/Whatsapp/whatsapp";
import EntityHelper from "@/mixins/EntitiesHelper";
import { postAPICall } from "@/helpers/httpHelper";
// import _ from "lodash";
import { fetchEntityRelationships } from "@/repo/entityRelationshipsRepo";
import { debounce } from "@/helpers/lodashHelper.js";

export default {
  name: "WAConfig",
  props: {
    title: {
      type: String,
      require: false,
      default: "Send WA Notification",
    },
    currentEntity: {
      type: Object,
      default: () => ({}),
    },
    entityData: {
      type: Object,
      require: false,
    },
    selectedIds: {
      type: String,
      require: false,
    },
    paramsContent: {
      type: Object,
      default: () => ({}),
    },
    isAutomation: {
      type: Boolean,
      default: true,
    },
    keyValue: {
      type: String,
      require: false,
    },
    allFields: {
      type: Array,
      default: () => [],
    },
    emailTemplateId: {
      type: String,
      require: false,
    },
    closeNotificationDialog: {
      type: Function,
      require: true,
    },
  },
  data() {
    return {
      waAccounts: [],
      openEntityNotification: true,
      WAparamsContent: {},
      entityNotificationBody: {
        subject: "",
        body: "",
        filters: [],
      },
      selectedEntityRelationships: [],
      isApplicationUserSide: false,
      whatsappTemplatesListDialog: false,
      componentCallType: "",
      editorConfig: JSON.parse(JSON.stringify(ckEditorConfig)),
      editorKey: 0,
      whatsapp_content: {
        body: "",
        subject: "",
        form: {},
      },
      form: {
        entity_id: "",
        filters: "",
        selectedFields: [],
      },
      email_parent_content: {
        header_body: "",
        footer_body: "",
        name: "",
      },
      event_code: "WA_WEB",
      email_fields: {
        user_types_emails: [],
        entity_fields: [],
        custom_emails: [],
        filters: [],
        wa_accountId: "",
      },
      cc_email_fields: {
        user_types_emails: [],
        entity_fields: [],
        custom_emails: [],
        filters: [],
      },
      bcc_email_fields: {
        user_types_emails: [],
        entity_fields: [],
        custom_emails: [],
        filters: [],
      },
      saveAsTemplateForm: {},
      allEntitiesData: [],
      entityAllFilters: [],
      filterLoading: false,
      selectedEntityFields: [],
      configureTableDialog: false,
      emailTemplatesParentListDialog: false,
      contactFields: [],
      userTypes: [],
      userTypesEmails: [],
      checkCC: false,
      checkBCC: false,
      checkTo: false,
      loadingText: "",
      allTocontactFields: [],
      userEmailsLoading: false,
      infoDialog: false,
      isOpened: false,
      relationshipsData: [],
      showHiddenFields: true,
      showTableHiddenFields: true,
      allCustomFields: [
        {
          id: "current_date",
          label: "Time - Current Date",
        },
        {
          id: "current_time",
          label: "Time - Current Time",
        },
        {
          id: "current_date_time",
          label: "Time - Current Date Time",
        },
        {
          id: "redirect_link_entity_data_edit",
          label: "Redirect Link - Company User - Data Edit",
        },
        {
          id: "redirect_link_entity_data_view",
          label: "Redirect Link - Company User - Data View",
        },
        {
          id: "redirect_link_ap_entity_data_edit",
          label: "Redirect Link - Application User - Data Edit",
        },
        {
          id: "redirect_link_ap_entity_data_view",
          label: "Redirect Link - Application User - Data View",
        },
      ],
      allCompanyFields: [],
      allCompanyDataFields: [],
      files: [],
      hasAttachment: false,
      isShowError: false,
      docFields: [],
      selectedDocuments: [],
      sendDataAsAttachment: false,
      sendDataAsAttachmentName: "",
      sendDataAsAttachmentDocument: "",
      selectedNotifyEntity: null,
      selectedNotifyEntityFilters: [],
      emailConfigLoading: false,
      copyField: "",
      allMentionableFields: [],
      entityDocuments: [],
      saveAsTemplateDialog: false,
      isTemplateCreated: false,
      relationalDataForm: {},
      relationalTableData: [],
      ckeditorLoading: false,
      mentionedRelationalTableFields: [],
      allEntityFields: [],
    };
  },
  async mounted() {
    this.getWAAccounts();
    if (this.currentEntity?.printing_documents) {
      this.fetchAllCompanyTemplates(this.currentEntity.printing_documents);
    }
    this.emailConfigLoading = true;
    this.loadingText = "Preparing Data";
    this.getCompanyInfo();
    if (this.emailTemplateId) {
      this.fetchEmailTemplate(this.emailTemplateId);
    }
    await this.prepareData();
    if (this.isAutomation) {
      await this.getExistedData();
    }
    this.emailConfigLoading = false;
    console.log("closeNotificationDialog", this.closeNotificationDialog);
  },
  mixins: [AutomationHelper, EntityHelper],
  computed: {
    ...mapGetters("entities", [
      "getAllEntities",
      "getEntityDataById",
      "getPageSize",
      "getEntityDataByEntityId",
      "getEntityDataUpdateStatus",
      "getEntityDocumentsDataStatus",
      "getEntityDocumentsData",
      "getEntityRecordsForTable",
      "getUploadCSVfileStatus",
      "getupdateMappedFieldStatus",
      "getmappedFieldsData",
      "getuploadedFilesData",
      "getstoreUploadedFileStatus",
      "getimportMappedDataStatusUpdatedVersion",
      "getentitydataBulkDeleteStatus",
      "getEntitydataBulkDeleteErrors",
      "getEntityShowFields",
      "getSentEntityDataNotificationStatus",
      "getEntityById",
      "getBulkUpdateStatus",
      "getSentEntityNotificationStatus",
      "getSentEntityNotificationStatusErrors",
      "getEntityDataByIdError",
      "getEntityVariableFieldsInputTypes",
    ]),
    ...mapGetters("s3FileUpload", [
      "getFileUploadData",
      "getCompanyLogoUpdateData",
      "getFileUploadStatus",
    ]),
    ...mapGetters("templatesData", [
      "getTemplateDeleteStatus",
      "getTemplateDeleteError",
      "getDownloadUrl",
      "getDownloadError",
      "getDuplicateEntityData",
    ]),
    ...mapGetters("filters", [
      "getAllEntityFilters",
      "getCreateNewFilter",
      "getUpdateFilterStatus",
      "getDeleteFilterStatus",
      "getCreateNewFilterError",
      "getUpdateFilterError",
      "getDeleteFilterErros",
    ]),
    ...mapGetters("entityRelationships", [
      "getEntityRelationships",
      "getCurrentEntityRelationships",
      "getParentEntityRelatiponshipData",
    ]),
    //...mapGetters("globalVariables", ["getAllGlobalVariables"]),
    ...mapGetters("auth", [
      "getAuthenticatedUser",
      "getDefaultDateFormat",
      "getActiveContactType",
      "getUserTypeEmailsErrors",
      "getUserTypeEmails",
      "getUserTypeList",
      "getActiveWorkspace",
      "getGlobalFiltervalue",
    ]),
    ...mapGetters("menuManagementV2", [
      "getMenu",
      "getMenuManagementAddStatus",
      "getMenuManagementUpdateStatus",
      "getEntityMenu",
    ]),
    ...mapGetters("applicationUsersPermission", [
      "getCreatePermissionStatus",
      "getEntityPermission",
      "getUpdatePermissionStatus",
    ]),
    ...mapGetters("navigationOpen", [
      "getIsOpen",
      "getIsCollapse",
      "getIsMobile",
    ]),
    ...mapGetters("contacts", ["getAllContacts"]),
    ...mapGetters("entityEmailTemplate", [
      "getEntityEmailTemplatesData",
      "getEmailTemplateError",
      "getCurrentEmailTemplateData",
    ]),
    ...mapGetters("company", ["getCompanyDetails"]),
    ...mapGetters("documents", ["getAllTemplates"]),
    getWAaccountsByEvent() {
      return () => {
        return this.waAccounts.filter((wa) => {
          return wa.type == this.event_code;
        });
      };
    },
  },
  methods: {
    async validateSenderAccount(id) {
      this.emailConfigLoading = true;
      this.loadingText = "Validating Whatsapp Account ...";
      let response = await postAPICall(
        "GET",
        "/wa/get-WA-single-integration-data",
        { _id: id }
      );
      if (response.success) {
        let validationResponse = await validateInstance(
          response.data[0].instanceId
        );
        if (validationResponse.state == "open") {
          this.emailConfigLoading = false;
          this.$notify({
            title: "Success",
            message: "Connection is active. You can proceed.",
            type: "success",
          });
        } else {
          this.emailConfigLoading = false;
          this.email_fields.wa_accountId = "";
          this.$notify({
            title: "Warning",
            message: "Connection is not active. Please change the connection.",
            type: "warning",
          });
          await postAPICall("PUT", "/wa/update-WA-single-integration-data", {
            _id: id,
          });
        }
      }
    },
    async getWAAccounts() {
      this.loading = true;
      this.loadingText = "Loading Whatsapp Accounts ...";
      let response = await postAPICall("GET", "/wa/get-WA-integration-data");

      if (response && response.success) {
        this.waAccounts = response.data;
        if (this.waAccounts.length == 1) {
          this.email_fields.wa_accountId = this.waAccounts[0]._id;
        }
        this.loading = false;
      }
    },
    async fetchEmailTemplate(id) {
      let params = {
        template_id: id,
      };
      await this.$store.dispatch(
        "entityEmailTemplate/currentTemplateData",
        params
      );
      if (this.getCurrentEmailTemplateData?._id) {
        console.log(
          "this.getCurrentEmailTemplateData0",
          this.getCurrentEmailTemplateData
        );
        this.entityNotificationBody.subject =
          this.getCurrentEmailTemplateData.subject;
        this.entityNotificationBody.body =
          this.getCurrentEmailTemplateData.content;
      }
    },
    async fetchAllCompanyTemplates(ids) {
      await this.$store.dispatch("documents/fetchAllTemplates", {
        include_configure_templates: ids,
      });
      this.entityDocuments =
        this.getAllTemplates && this.getAllTemplates.data
          ? this.getAllTemplates.data
          : [];
      //if default first option not working
      if (this.entityDocuments.length) {
        this.sendDataAsAttachmentDocument =
          this.entityDocuments[0].configurable_document_id;
      }
    },
    getEntityFields(fields) {
      if (fields && fields.length && this.isAutomation) {
        return fields;
      }
      return [];
    },
    whatsappTemplateListDialog() {
      this.whatsappTemplatesListDialog = false;
    },
    emailTemplateParentListDialog() {
      this.emailTemplatesParentListDialog = false;
    },
    ConfigureTableDialog() {
      this.configureTableDialog = false;
    },
    checkIsDisabled() {
      if (
        this.email_fields.wa_accountId != "" &&
        !this.email_fields.entity_fields?.length &&
        !this.email_fields.custom_emails?.length
      ) {
        return true;
      }
      return false;
    },
    resetEntityNotification() {
      this.entityNotificationBody.subject = "";
      this.entityNotificationBody.body = "";
      this.entityNotificationBody.filters = [];
      this.openEntityNotification = false;
      // this.selectedEntityRelationships = [];
      this.email_fields = {
        user_types_emails: [],
        entity_fields: [],
        custom_emails: [],
        filters: [],
      };
      this.bcc_email_fields = {
        user_types_emails: [],
        entity_fields: [],
        custom_emails: [],
        filters: [],
      };
      this.cc_email_fields = {
        user_types_emails: [],
        entity_fields: [],
        filters: [],
        custom_emails: [],
      };
      this.checkBCC = false;
      this.checkCC = false;
      this.checkTo = true;
      this.email_parent_content = {
        header_body: "",
        footer_body: "",
        name: "",
      };
      this.files = [];
      this.hasAttachment = false;
      this.selectedDocuments = [];
      this.form = {
        entity_id: "",
        selectedFields: [],
        filters: "",
      };
      this.sendDataAsAttachment = false;
      this.showHiddenFields = true;
      this.showTableHiddenFields = true;
      this.sendDataAsAttachmentName = "";
      this.sendDataAsAttachmentDocument = "";
    },
    chooseFromWhatsappTemplates() {
      this.whatsappTemplatesListDialog = true;
      this.componentCallType = "ENTITY";
    },
    handleSaveAsTemplate() {
      let isValid = this.validateContent();
      if (!isValid.value) {
        return this.$message.warning(isValid.message);
      }
      let pattern = /\[\[([^[\]]*)\]\]/g;
      let mentionedSubjectLabels = [];
      let labelAndFields = {};
      this.allMentionableFields.map((e) => {
        labelAndFields[e.label] = e;
      });
      let match;
      let isSubjectValid = true;
      let notSupportedSubjectTypes = [
        "IMAGE",
        "SIGNATURE",
        "PAY_BUTTON",
        "FILE",
        "DATA_TABLE",
        "MULTI_LINE_TEXT",
      ];
      while (
        (match = pattern.exec(this.entityNotificationBody.subject)) !== null
      ) {
        mentionedSubjectLabels.push(match[1]);
      }
      mentionedSubjectLabels.map((e) => {
        const template = labelAndFields[e];
        if (!template) {
          isSubjectValid = false;
        }
        if (notSupportedSubjectTypes.includes(template?.input_type)) {
          isSubjectValid = false;
        }
      });
      if (!isSubjectValid) {
        return this.$message.warning(
          "Please remove Invalid fields from your subject"
        );
      }
      this.saveAsTemplateForm = {
        subject: this.entityNotificationBody.subject,
        content: this.entityNotificationBody.body,
        entity_id: this.currentEntity._id,
      };
      if (
        this.entityNotificationBody.body.includes(
          "[[relationalEntityDataTable]]"
        )
      ) {
        this.relationalDataForm = { ...this.form };
      }
      this.saveAsTemplateDialog = true;
    },
    closeSaveAsTemplateDialog() {
      this.saveAsTemplateDialog = false;
    },
    handleTemplateCreated() {
      this.saveAsTemplateDialog = false;
      this.isTemplateCreated = true;
    },
    async openSendNotification() {
      this.allMentionableFields = await this.fetchEntityDetails(
        this.currentEntity._id,
        true,
        true
      );
      this.allEntityFields = JSON.parse(
        JSON.stringify(this.allMentionableFields)
      );
      this.contactFields = [];
      this.docFields = [];
      let fieldsObject = {};
      let standardTemplateData = await axios.get("/get-standard-template");
      let standardTemplate = standardTemplateData.data.data;
      let notSupportedSubjectTypes = [
        "IMAGE",
        "SIGNATURE",
        "PAY_BUTTON",
        "FILE",
        "DATA_TABLE",
        "MULTI_LINE_TEXT",
      ];
      const entityPromises = [];

      this.allMentionableFields = (this.allMentionableFields || []).map((e) => {
        if (e.input_type === "ENTITY_VARIABLE" || e.input_type === "ENTITY") {
          if (
            e.global_variable_entity_field === `${standardTemplate._id}#phone`
          ) {
            this.contactFields.push(e);
          } else if (e.inputType === "PHONE_COUNTRY_CODE") {
            this.contactFields.push(e);
          } else if (e.inputType === "ENTITY") {
            entityPromises.push(
              this.fetchEntityDetails(e.entity_id).then((entityFields) => {
                entityFields.forEach((element) => {
                  if (
                    element.template_key === e.primary_fields[0] &&
                    element.inputType === "PHONE_COUNTRY_CODE"
                  ) {
                    this.contactFields.push(e);
                  }
                });
              })
            );
          }
        } else if (e.input_type === "SIGNATURE") {
          return;
        } else if (e.input_type === "FILE") {
          this.docFields.push(e);
        } else if (e.input_type === "PHONE_COUNTRY_CODE") {
          this.contactFields.push(e);
        }

        fieldsObject[e.key] = e;
        return {
          label: e.label,
          template_key: e.template_key,
          id: e.template_key,
          input_type: e.inputType,
          key: e.key,
          isSubjectSupported: !notSupportedSubjectTypes.includes(e.inputType),
        };
      });

      await Promise.all(entityPromises);
      this.docFields = Array.from(new Set(this.docFields));
      this.contactFields = Array.from(new Set(this.contactFields));
      this.loading = false;
      this.editorConfig.height = 300;
      this.editorConfig.width = 700;
      this.editorConfig.mentions = [
        {
          feed: this.dataFeed,
          itemTemplate:
            '<li data-id="{id}">' +
            '<strong class="label">{label}</strong>' +
            // '<span class="fullname">{fullname}</span>' +
            "</li>",
          outputTemplate: (item) => {
            if (item.input_type == "IMAGE" || item.inputType == "IMAGE") {
              return `<img alt="${item.label}" 
                            src="https://app-esigns-io.s3.amazonaws.com/ck_editor_assets/MicrosoftTeams-image_8-1716639572596.png?field=[[${item.label}]]" 
                            style="width: 80px;"
                            title="${item.label}" />`;
            } else {
              return `<span>&nbsp;</span><span>[[${item.label}]]</span><span>&nbsp;</span>`;
            }
          },
          minChars: 0,
          convertTo: function (item) {
            return {
              template_key: item.label,
            };
          },
        },
        {
          feed: this.companyDataFeed,
          marker: "#",
          itemTemplate:
            '<li data-id="{id}">' +
            '<strong class="label">{label}</strong>' +
            "</li>",
          outputTemplate:
            "<span>&nbsp;</span><strong>(({id}))</strong><span>&nbsp;</span>",
          minChars: 0,
        },
      ];
      this.selectedNotifyEntity = this.entityData || {};
      this.selectedEntityRelationships = [];
      if (this.fetchedRelationships) {
        this.selectedEntityRelationships = [...this.fetchedRelationships];
        // we have to add type owner of relationship
        this.selectedEntityRelationships =
          await this.selectedEntityRelationships.map((e) => {
            e.entity_id = this.currentEntity._id;
            if (
              e.parent_entity_id == this.currentEntity._id ||
              e.parent_entity_id?._id == this.currentEntity._id
            ) {
              e.owner_type = "PARENT";
              e.relationship_id = e.child_entity_id?._id || e.child_entity_id;
              e.relationship_title = e.child_relation_title;
              e.relationship_entity_type = e.child_entity_id?.entity_type || "";
              e.entity_name = e.child_entity_id?.name || "";
            } else {
              e.owner_type = "CHILD";
              e.relationship_id = e.parent_entity_id?._id || e.parent_entity_id;
              e.relationship_title = e.parent_relation_title;
              e.relationship_entity_type =
                e.parent_entity_id?.entity_type || "";
              e.entity_name = e.parent_entity_id?.name || "";
            }
            return e;
          });
        //remove general entities
        this.selectedEntityRelationships =
          this.selectedEntityRelationships.filter(
            (relation) => relation?.relationship_entity_type != "GENERAL"
          );
        this.selectedEntityRelationships =
          this.selectedEntityRelationships.filter((e) => {
            if (e.owner_type == "CHILD" && !e.is_bidirectional) {
              return false;
            } else {
              return true;
            }
          });
      }
      if (this.contactFields.length) {
        this.email_fields.entity_fields.push(
          this.contactFields[0].template_key
        );
      } else if (this.selectedEntityRelationships.length) {
        this.email_fields.filters.push(
          `RELATION#${this.selectedEntityRelationships[0]._id}`
        );
      } else if (
        this.userTypesEmails.length &&
        this.userTypesEmails[0].options &&
        this.userTypesEmails[0].options.length
      ) {
        this.email_fields.user_types_emails.push(
          this.userTypesEmails[0].options[0]
        );
      }
      if (this.currentEntity?.entity_type == "INDIVIDUAL") {
        this.entityNotificationBody.filters = ["SELF"];
      } else if (this.currentEntity?.entity_type == "BUSINESS") {
        this.entityNotificationBody.filters = ["CONTACTS"];
      }
      if (this.checkBulkSendCondition()) {
        await this.$store.dispatch("filters/fetchAllEntityFilters", {
          entityId: this.currentEntity._id,
        });
        if (this.getAllEntityFilters) {
          this.selectedNotifyEntityFilters = this.getAllEntityFilters;
        }
      }
    },
    async getExistedData() {
      this.loadingText = "Fetching existed data";
      this.WAparamsContent = this.paramsContent;
      let data = this.WAparamsContent;
      if (data.body) {
        data.body = data.body.replace(/\[\[(.*?)\]\]/g, (match, key) => {
          const template = (this.allMentionableFields || []).find((obj) => {
            const parts = obj.template_key.split("#");
            return (
              parts[0] === key.split("#")[0] && parts[1] === key.split("#")[1]
            );
          });
          return template ? `[[${template?.label}]]` : match;
        });
        if (data.body.includes("{{relationalEntityDataTable}}")) {
          data.body = data.body.replace(
            "{{relationalEntityDataTable}}",
            "[[relationalEntityDataTable]]"
          );
        }
        this.entityNotificationBody.body = data.body;
      }
      if (data.subject) {
        data.subject = data.subject.replace(/\[\[(.*?)\]\]/g, (match, key) => {
          const template = this.allMentionableFields.find((obj) => {
            const parts = obj.template_key.split("#");
            return (
              parts[0] === key.split("#")[0] && parts[1] === key.split("#")[1]
            );
          });
          return template ? `[[${template?.label}]]` : match;
        });
        this.entityNotificationBody.subject = data.subject;
      }
      if (data.attachment_fields && data.attachment_fields.length) {
        this.hasAttachment = true;
        this.selectedDocuments = [...data.attachment_fields];
      }
      if (data.bcc_email_fields && Object.keys(data.bcc_email_fields).length) {
        this.checkBCC = true;
        this.bcc_email_fields = {
          ...data.bcc_email_fields,
        };
      }
      if (data.cc_email_fields && Object.keys(data.cc_email_fields).length) {
        this.checkCC = true;
        this.cc_email_fields = {
          ...data.cc_email_fields,
        };
      }
      if (data.email_fields && Object.keys(data.email_fields).length) {
        this.email_fields = {
          ...data.email_fields,
        };
      }
      if (
        data.mentionedRelationalTableFields?.length &&
        data?.relationalTableData?.length
      ) {
        this.mentionedRelationalTableFields = [
          ...data?.mentionedRelationalTableFields,
        ];
        this.relationalTableData = [...data?.relationalTableData];
      }
      if (data.send_data_as_attachment) {
        this.sendDataAsAttachment = true;
        data.send_data_as_attachment_name =
          data.send_data_as_attachment_name.replace(
            /\[\[(.*?)\]\]/g,
            (match, key) => {
              const template = this.allMentionableFields.find((obj) => {
                const parts = obj.template_key.split("#");
                return (
                  parts[0] === key.split("#")[0] &&
                  parts[1] === key.split("#")[1]
                );
              });
              return template ? `[[${template?.label}]]` : match;
            }
          );
        this.sendDataAsAttachmentName = data.send_data_as_attachment_name;
        this.sendDataAsAttachmentDocument =
          data.send_data_as_attachment_document ||
          this.currentEntity.default_printing_document;
      }
      if (!data.show_hidden_fields) {
        this.showHiddenFields = false;
      }
      if (!data.show_table_hidden_fields) {
        this.showTableHiddenFields = false;
      }
      if (data.attachments && data.attachments.length) {
        this.loadingText = "Fetching attachments";
        this.hasAttachment = true;
        let params = {
          paths: data.attachments,
        };
        await this.$store.dispatch(
          "s3FileUpload/getDataFromPresignedUrls",
          params
        );
        if (this.getFileUploadData) {
          this.files = [...this.getFileUploadData];
        }
      }
      if (
        data.email_parent_content &&
        Object.keys(data.email_parent_content).length
      ) {
        this.email_parent_content = {
          ...data.email_parent_content,
        };
      }
    },
    sendNotification() {
      this.emailConfigLoading = true;
      let isValid = this.validateContent();
      if (!isValid.value) {
        this.emailConfigLoading = false;
        return this.$message.warning(isValid.message);
      }
      const childRegex = /\[\[(.*?)\]\]/g;
      const childVariables = [];
      let hasHtml = false;
      let htmlFields = ["DATA_TABLE", "RICH_TEXT"];
      let labelAndFields = {};
      this.allMentionableFields.map((e) => {
        labelAndFields[e.label] = e;
      });
      let match;
      while (
        (match = childRegex.exec(this.entityNotificationBody.body)) !== null
      ) {
        if (htmlFields.includes(labelAndFields[match[1]]?.input_type)) {
          hasHtml = true;
        }
        childVariables.push(match[1]);
      }
      const customRegex = /\(\(([^)]+)\)\)/g;
      let customVariables = [];
      while (
        (match = customRegex.exec(this.entityNotificationBody.body)) !== null
      ) {
        customVariables.push(match[1]);
      }
      let mentionedFields = [];
      let mentionedAttachmentNameFields = [];
      let variables = {};
      // let filters = [];
      //   let isSubjectValid = true;
      //   let notSupportedSubjectTypes = [
      //     "IMAGE",
      //     "SIGNATURE",
      //     "PAY_BUTTON",
      //     "FILE",
      //     "DATA_TABLE",
      //     "MULTI_LINE_TEXT",
      //   ];
      //   let pattern = /\[\[([^[\]]*)\]\]/g;
      //   let mentionedSubjectLabels = [];

      //   while (
      //     (match = pattern.exec(this.entityNotificationBody.subject)) !== null
      //   ) {
      //     mentionedSubjectLabels.push(match[1]);
      //   }
      //   mentionedSubjectLabels.map((e) => {
      //     const template = labelAndFields[e];
      //     if (!template) {
      //       isSubjectValid = false;
      //     }
      //     if (notSupportedSubjectTypes.includes(template?.input_type)) {
      //       isSubjectValid = false;
      //     }
      //   });
      //   if (!isSubjectValid) {
      //     return this.$message.warning(
      //       "Please remove Invalid fields from your subject"
      //     );
      //     // this.$alert("Do you want to remove unsupported fields", "Title", {
      //     //   confirmButtonText: "OK",
      //     //   callback: () => {
      //     //     return;
      //     //   },
      //     // });
      //   }
      //   this.entityNotificationBody.subject =
      //     this.entityNotificationBody.subject.replace(
      //       /\[\[(.*?)\]\]/g,
      //       (match, label) => {
      //         const template = labelAndFields[label];
      //         if (!template) {
      //           return "-";
      //         }
      //         mentionedSubjectFields.push(template.template_key);
      //         return template ? `[[${template?.template_key}]]` : match;
      //       }
      //     );
      if (
        this.isSendIndividual ||
        (!this.isSendIndividual &&
          ((this.hasAttachment &&
            this.selectedDocuments &&
            this.selectedDocuments.length) ||
            this.sendDataAsAttachment ||
            hasHtml)) ||
        this.checkHasCustomEmail()
      ) {
        this.entityNotificationBody.body =
          this.entityNotificationBody.body.replace(
            /\[\[(.*?)\]\]/g,
            (match, label) => {
              if (label.includes("DataTable-")) {
                return `[[${label}]]`;
              }
              const template = labelAndFields[label];
              if (!template) {
                return "--";
              }
              if (template?.input_type == "PAY_BUTTON") {
                mentionedFields.push(`${template?.template_key}#pay`);
                return template ? `[[${template.template_key}#pay]]` : match;
              }
              mentionedFields.push(template.template_key);
              return template ? `[[${template?.template_key}]]` : match;
            }
          );
      } else {
        this.entityNotificationBody.body =
          this.entityNotificationBody.body.replace(
            /\[\[(.*?)\]\]/g,
            (match, label) => {
              const template = labelAndFields[label];
              if (!template) {
                return "--";
              }
              if (template?.input_type == "PAY_BUTTON") {
                mentionedFields.push(`${template?.template_key}#pay`);
                variables[`${template?.template_key}#pay`] = template.key;
                return template ? `{{${template.key}}}` : match;
              }
              mentionedFields.push(template.template_key);
              variables[template.template_key] = template.key;
              return template ? `{{${template.key}}}` : match;
            }
          );
        this.entityNotificationBody.body =
          this.entityNotificationBody.body.replace(
            /\(\(([^)]+)\)\)/g,
            "{{$1}}"
          );
      }
      this.WAparamsContent = {
        entity_type: this.currentEntity.entity_type,
        subject: this.entityNotificationBody.subject,
        body: this.entityNotificationBody.body,
        entity_id: this.currentEntity._id,
        mentioned_fields: mentionedFields,
        email_fields: this.email_fields,
      };
      if (this.isSendIndividual && this.selectedNotifyEntity?._id) {
        // this.WAparamsContent["filters"] = filters;
        this.WAparamsContent["entity_data_id"] = this.selectedNotifyEntity._id;
      } else {
        // this.WAparamsContent["email_fields"] = this.email_fields;
        this.WAparamsContent["variables"] = variables;
        if (hasHtml) {
          this.WAparamsContent["hasHtml"] = true;
        }
        if (this.selectedIds && this.selectedIds?.length) {
          this.WAparamsContent["entity_data_ids"] = this.selectedIds;
        }
        if (
          (this.hasAttachment &&
            this.selectedDocuments &&
            this.selectedDocuments.length) ||
          this.sendDataAsAttachment ||
          hasHtml ||
          this.checkHasCustomEmail()
        ) {
          this.WAparamsContent["send_individually"] = true;
        }
      }
      if (this.checkBCC) {
        this.WAparamsContent["bcc_email_fields"] = this.bcc_email_fields;
      }
      if (this.checkCC) {
        this.WAparamsContent["cc_email_fields"] = this.cc_email_fields;
      }
      this.WAparamsContent["mentionedSubjectFields"] = [];

      if (customVariables && customVariables.length) {
        this.WAparamsContent["custom_variables"] = customVariables;
      }
      if (
        this.email_parent_content.footer_body &&
        this.email_parent_content.header_body
      ) {
        this.WAparamsContent["email_parent_content"] =
          this.email_parent_content;
      }
      if (this.hasAttachment && this.files && this.files.length) {
        this.WAparamsContent["attachments"] = this.getAttachmentFiles();
      }
      if (
        this.hasAttachment &&
        this.selectedDocuments &&
        this.selectedDocuments.length
      ) {
        this.WAparamsContent["attachment_fields"] = this.selectedDocuments;
      }
      if (this.sendDataAsAttachment) {
        this.sendDataAsAttachmentName = this.sendDataAsAttachmentName.replace(
          /\[\[(.*?)\]\]/g,
          (match, label) => {
            const template = labelAndFields[label];
            if (!template) {
              return "-";
            }
            mentionedAttachmentNameFields.push(template.template_key);
            return template ? `[[${template?.template_key}]]` : match;
          }
        );
        this.WAparamsContent["send_data_as_attachment"] = true;
        this.WAparamsContent["send_data_as_attachment_name"] =
          this.sendDataAsAttachmentName;
        this.WAparamsContent["send_data_as_attachment_document"] =
          this.sendDataAsAttachmentDocument;
        this.WAparamsContent["mentionedAttachmentNameFields"] =
          mentionedAttachmentNameFields;
      }
      if (this.showHiddenFields) {
        this.WAparamsContent["show_hidden_fields"] = true;
      }
      if (this.showTableHiddenFields) {
        this.WAparamsContent["show_table_hidden_fields"] = true;
      }
      if (this.mentionedRelationalTableFields?.length) {
        this.WAparamsContent["mentionedRelationalTableFields"] =
          this.mentionedRelationalTableFields;
        this.WAparamsContent["relationalTableData"] = this.relationalTableData;
        this.WAparamsContent["send_individually"] = true;
        //clearing unwanted declarations of this format
        let regex = /\[\[DataTable-([^\]]+)\]\]/g;
        this.entityNotificationBody.body =
          this.entityNotificationBody.body.replace(
            regex,
            (match, fieldName) => {
              if (this.mentionedRelationalTableFields.includes(fieldName)) {
                return match;
              } else {
                return "";
              }
            }
          );
      }
      if (
        this.checkBulkSendCondition() &&
        this.entityNotificationBody.filter_id
      ) {
        this.WAparamsContent["filter_id"] =
          this.entityNotificationBody.filter_id;
      }
      this.WAparamsContent.event_type = "WA"; // For whatsapp
      this.WAparamsContent.event_code = this.event_code;
      this.WAparamsContent.wa_accountId = this.email_fields.wa_accountId;
      this.emailConfigLoading = false;
      console.log("WAparamsContent0ccccccc", this.WAparamsContent);
      this.closeNotificationDialog(this.WAparamsContent);
      console.log("emitted.....closeNotificationDialogWAparamsContent");

      this.WAparamsContent = {};
      this.resetEntityNotification();
    },
    dataFeed(opts, callback) {
      var matchProperty = "label",
        data = (this.allMentionableFields || []).filter(function (item) {
          return (
            item[matchProperty]
              .toLowerCase()
              .indexOf(opts.query.toLowerCase()) !== -1
          );
        });
      data = data.sort(function (a, b) {
        return a[matchProperty].localeCompare(b[matchProperty], undefined, {
          sensitivity: "accent",
        });
      });
      callback(data);
    },
    companyDataFeed(opts, callback) {
      var matchProperty = "label",
        data = this.allCompanyDataFields.filter(function (item) {
          return (
            item[matchProperty]
              .toLowerCase()
              .indexOf(opts.query.toLowerCase()) !== -1
          );
        });
      data = data.sort(function (a, b) {
        return a[matchProperty].localeCompare(b[matchProperty], undefined, {
          sensitivity: "accent",
        });
      });
      callback(data);
    },
    async prepareData() {
      if (
        this.$route.path.includes("/ap/") ||
        this.$route.name == "ApEntityExecute" ||
        this.$route.name == "ApPreviewEntityData"
      ) {
        this.isApplicationUserSide = true;
      }
      this.resetEntityNotification();
      // if(!this.userTypes?.length ||
      //   !this.allEntitiesData?.length ||
      //   !this.userTypesEmails?.length) {
      // Promise.all([
      //   await this.fetchEntities(),
      //   await this.getCompanyUserTypeList(),
      //   await this.getUserTypeEmailsList(),
      // ]);
      // }
      if (this.getUserTypeEmails && this.getUserTypeList) {
        this.userTypes = this.getUserTypeList;
        this.userTypesEmails = this.getUserTypeEmails.data;
      }
      await this.fetchEntities(), await this.openSendNotification();
      this.isOpened = true;
    },
    chooseFromParentEmailTemplates() {
      this.emailTemplatesParentListDialog = true;
      this.componentCallType = "PARENT";
    },
    async closeTemplatesList() {
      this.loadingText = "Fetching data....";
      this.ckeditorLoading = true;
      if (this.componentCallType == "ENTITY") {
        this.entityNotificationBody.body = this.parseEmailTemplate(
          /\[\[([^[\]]*)\]\]/g,
          this.whatsapp_content.body,
          this.allEntityFields,
          true
        );
        this.entityNotificationBody.subject = this.parseEmailTemplate(
          /\[\[([^[\]]*)\]\]/g,
          this.whatsapp_content.subject,
          this.allEntityFields,
          true
        );
        if (
          this.whatsapp_content.mentionedRelationalTableFields?.length &&
          this.whatsapp_content?.relationalTableData?.length
        ) {
          this.mentionedRelationalTableFields = [
            ...this.whatsapp_content?.mentionedRelationalTableFields,
          ];
          this.relationalTableData = [
            ...this.whatsapp_content?.relationalTableData,
          ];
        }
        this.ckeditorLoading = false;
        this.emailTemplatesListDialog = false;
        this.whatsappTemplatesListDialog = false;
      } else {
        // this.entityNotificationBody['parent_content'] = this.email_parent_content;
        this.emailTemplatesParentListDialog = false;
      }
      this.ckeditorLoading = false;
      this.emailConfigLoading = false;
    },
    checkHasCustomEmail() {
      return true; // Whatsapp Always send messages individually message
    },
    handleTableConfigClose(data) {
      this.ckeditorLoading = true;
      this.loadingText = "Fetching Table data....";
      this.relationalTableData = [...data];
      this.mentionedRelationalTableFields = [];
      this.relationalTableData.map((e) => {
        this.mentionedRelationalTableFields.push(e.name);
        if (
          (e.type == "email_body" || e.typee == "dataTable") &&
          !this.entityNotificationBody.body.includes(`[[DataTable-${e.name}]]`)
        ) {
          // let key = Math.floor(Math.random() * 100000);
          this.entityNotificationBody.body =
            this.entityNotificationBody.body +
            `<br> [[DataTable-${e.name}]] &nbsp;&nbsp;`;
        }
      });
      let regex = /\[\[DataTable-([^\]]+)\]\]/g;
      this.entityNotificationBody.body =
        this.entityNotificationBody.body.replace(regex, (match, fieldName) => {
          if (this.mentionedRelationalTableFields.includes(fieldName)) {
            return match;
          } else {
            return "";
          }
        });

      this.configureTableDialog = false;
      this.ckeditorLoading = false;
    },
    // async getCompanyUserTypeList() {
    //   if (this.getActiveWorkspace && this.getActiveWorkspace?.company_id) {
    //     try {
    //       await this.$store.dispatch("auth/getUserTypeList", {
    //         companyId: this.getActiveWorkspace.company_id,
    //         isMenu: true,
    //       });
    //       if (this.getUserTypeList) {
    //         this.userTypes = this.getUserTypeList;
    //       }
    //     } catch (err) {
    //       this.$notify.error({
    //         title: "Error",
    //         message: err,
    //       });
    //     }
    //   }
    // },
    // async getUserTypeEmailsList() {
    //   try {
    //     this.userEmailsLoading = true;
    //     if (!this.userTypes.length) {
    //       this.userEmailsLoading = false;
    //       return ;
    //     }
    //     let AllUserTypeIds = this.userTypes.map((e) => e._id);
    //     let params = {
    //       userTypes: AllUserTypeIds,
    //     };
    //     await this.$store.dispatch("auth/fetchUserTypeEmails", params);
    //     if (this.getUserTypeEmails) {
    //       this.userTypesEmails = this.getUserTypeEmails.data;
    //       this.userEmailsLoading = false;
    //     }
    //   } catch (err) {
    //     this.userEmailsLoading = false;
    //     this.$notify.error({
    //       title: "Error",
    //       message: this.getUserTypeEmailsErrors,
    //     });
    //   }
    //   this.userEmailsLoading = false;
    //   return;
    // },
    getLabelByUserTypeId(userTypeId) {
      let userTypeData = this.userTypes.filter((e) => e._id == userTypeId);
      if (userTypeData?.[0] && userTypeData?.[0].role) {
        return userTypeData?.[0].role.title + " - " + userTypeData?.[0]?.name;
      } else {
        return userTypeData?.[0].name;
      }
    },
    // handleToEmailChange(type) {
    //   switch (type) {
    //     case "custom":
    //       this.email_fields.user_types_email = "";
    //       this.email_fields.entity_field = "";
    //       this.email_fields.relational_field = "";
    //       break;
    //     case "entity_field":
    //       this.email_fields.custom_email = "";
    //       this.email_fields.user_types_email = "";
    //       this.email_fields.relational_field = "";
    //       break;
    //     case "user_type_email":
    //       this.email_fields.custom_email = "";
    //       this.email_fields.entity_field = "";
    //       this.email_fields.relational_field = "";
    //       break;
    //     case "relational_field":
    //       this.email_fields.custom_email = "";
    //       this.email_fields.entity_field = "";
    //       this.email_fields.user_types_email = "";
    //       break;
    //     default:
    //       this.email_fields.custom_email = "";
    //       this.email_fields.user_types_email = "";
    //       this.email_fields.entity_field = "";
    //       this.email_fields.relational_field = "";
    //       break;
    //   }
    // },
    async getCompanyInfo() {
      const fieldMappings = {
        about_company_text: "Company - Description",
        email_domain: "Company - Email Domain",
        email_footer_text: "Company - Email Footer",
        legal_name: "Company - Legal Name",
        name: "Company - Name",
        logo: "Company - Logo",
        address: "Company - Address",
      };
      this.allCompanyFields = Object.entries(fieldMappings).map(
        ([field, label]) => {
          return {
            label,
            id: field,
          };
        }
      );
      this.allCompanyDataFields = [
        ...this.allCustomFields,
        ...this.allCompanyFields,
      ];
      const userFieldMappings = {
        first_name: "Login User - First Name",
        last_name: "Login User - Last Name",
        email: "Login User - Email",
        phone: "Login User - Phone",
        address: "Login User - Address",
        owner_first_name: "Owner - First Name",
        owner_last_name: "Owner - Last Name",
        owner_email: "Owner - Email",
        owner_phone: "Owner - Phone",
        owner_address: "Owner - Address",
      };
      let userFields = Object.entries(userFieldMappings).map(
        ([field, label]) => {
          return {
            label,
            value: field,
            id: field,
          };
        }
      );
      this.allUserFields = userFields;
      this.allCompanyDataFields = [...this.allCompanyDataFields, ...userFields];
    },
    uploadFile(file) {
      if (
        file.type != "audio/mpeg" &&
        file.type != "video/mp4" &&
        file.type != "image/gif" &&
        file.type != "text/html" &&
        file.type != "text/css" &&
        file.type != "text/javascript" &&
        file.type != "application/json" &&
        file.type != "" &&
        file.type != "application/x-msdownload"
      ) {
        let totalSize = this.files.reduce((total, file) => {
          return total + file.size;
        }, 0);
        // if (file.size < 5000000 && totalSize < 10000000) {
        if (file.size < 5000000 && totalSize < 10000000) {
          const reader = new FileReader();

          reader.onload = (event) => {
            file.base64 = event.target.result.split(",")[1];
            const fileType = event.target.result.split(",")[0];
            file.type = fileType.split(";")[0].split(":")[1];
            this.files.push(file);
          };

          reader.onerror = (error) => {
            console.error("Error reading the file:", error);
          };

          reader.readAsDataURL(file.raw);
        } else {
          this.$message.error("Large files. Maximum upload file size: 10 MB");
        }
      } else {
        this.$message("File format is not supported");
      }
    },
    resetParent() {
      this.email_parent_content = {
        header_body: "",
        footer_body: "",
        name: "",
      };
    },
    async deleteItem(index) {
      this.files.splice(index, 1);
    },
    getAttachmentFiles() {
      let data = this.files.map((e) => {
        return {
          filename: e.name,
          type: e.raw.type,
          content: e.base64,
          size: e.size,
        };
      });
      return data;
    },
    checkBulkSendCondition() {
      if (
        !this.isSendIndividual &&
        !(this.selectedIds && this.selectedIds?.length)
      ) {
        return true;
      }
      return false;
    },
    validateContent() {
      if (this.sendDataAsAttachment && !this.sendDataAsAttachmentName) {
        return {
          value: false,
          message: "Please Enter Printing Name",
        };
      } else if (
        !(
          (
            this.entityNotificationBody.body &&
            this.entityNotificationBody.body.length > 10
          )
          // && this.entityNotificationBody.body.length<1024
        )
      ) {
        return {
          value: false,
          message: "body must be gather then 10 characters",
        };
      } else if (!this.email_fields.wa_accountId) {
        return {
          value: false,
          message: "Please choose WA sender account.",
        };
      }
      const leftBracesCount =
        this.entityNotificationBody.body.split("[[").length - 1;
      const rightBracesCount =
        this.entityNotificationBody.body.split("]]").length - 1;
      if (leftBracesCount < rightBracesCount) {
        return {
          value: false,
          message: "Please remove unwanted ]]",
        };
      } else if (leftBracesCount > rightBracesCount) {
        return {
          value: false,
          message: "Please remove unwanted [[",
        };
      }
      const regex = /\[\[\s*]]/g;
      if (regex.test(this.entityNotificationBody.body)) {
        return {
          value: false,
          message: "There should be field inside [[ ]]",
        };
      }
      // Check for [[ before ]]
      if (/\[\[[^\]]*\[\[/.test(this.entityNotificationBody.body)) {
        return {
          value: false,
          message: "No [[ allowed inside double brackets",
        };
      }

      //checking custom variables
      const leftParenthesesCount =
        this.entityNotificationBody.body.split("((").length - 1;
      const rightParenthesesCount =
        this.entityNotificationBody.body.split("))").length - 1;

      if (leftParenthesesCount < rightParenthesesCount) {
        return {
          value: false,
          message: "Please remove unwanted ))",
        };
      } else if (leftParenthesesCount > rightParenthesesCount) {
        return {
          value: false,
          message: "Please remove unwanted ((",
        };
      }

      const regexParentheses = /\(\(\s*\)\)/g;
      if (regexParentheses.test(this.entityNotificationBody.body)) {
        return {
          value: false,
          message: "There should be content inside (( ))",
        };
      }

      // Check for (( before ))
      if (/\(\((^\))*\(\(/.test(this.entityNotificationBody.body)) {
        return {
          value: false,
          message: "No (( allowed inside double parentheses",
        };
      }
      return {
        value: true,
      };
    },
    async fetchEntities() {
      try {
        // this.loading = true;
        let params = {
          get_all: true,
        };
        let relationalEntityIds = [];
        this.loadingText = "Fetching Relationships...";
        let [fetchedEntityRelationships] = await Promise.all([
          fetchEntityRelationships({
            entity_id: this.currentEntity._id,
            include_type: true,
          }),
          this.$store.dispatch("entities/fetchEntities", params),
          // this.$store.dispatch("entityRelationships/fetchEntityRelationships", {
          //   entity_id: this.currentEntity._id,
          //   include_type: true,
          // }),
        ]);
        if (fetchedEntityRelationships) {
          this.fetchedRelationships = [...(fetchedEntityRelationships || [])];
          // this.relationshipsData = this.getEntityRelationships.filter(
          //   (e) => {
          //     if (e.owner_type == "CHILD" && !e.is_bidirectional) {
          //       return false;
          //     } else {
          //       return true;
          //     }
          //   }
          // );
          (fetchedEntityRelationships || []).map((e) => {
            // if (e.owner_type == "CHILD" || e.representation == "TAB") {
            relationalEntityIds = [
              ...relationalEntityIds,
              e.child_entity_id?._id,
              e.parent_entity_id?._id,
            ];
            // }
          });
          relationalEntityIds = Array.from(new Set(relationalEntityIds));
          if (relationalEntityIds && relationalEntityIds.length) {
            let indexToDelete = relationalEntityIds.indexOf(
              this.currentEntity._id
            );
            if (indexToDelete !== -1) {
              relationalEntityIds.splice(indexToDelete, 1);
            }
          }
        }
        this.allEntitiesData = (this.getAllEntities.data || []).filter((e) => {
          if (relationalEntityIds.includes(e._id)) {
            return e;
          }
          return null;
        });
        // this.loading = false;
      } catch (err) {
        // this.loading = false;
        console.log("fetchEntities", err);
      }
    },
    async getEntityFilters(entity_id) {
      this.loadingText = "Fetching filters";
      this.filterLoading = true;
      await this.$store.dispatch("filters/fetchAllEntityFilters", {
        entityId: entity_id,
      });
      this.entityAllFilters = [];
      if (this.form.filters) {
        this.form.filters = "";
      }
      if (this.getAllEntityFilters) {
        this.entityAllFilters = this.getAllEntityFilters;
      }
      this.form.selectedFields = [];
      this.selectedEntityFields = await this.fetchEntityDetails(
        entity_id,
        true,
        true
      );
      this.selectedEntityFields = this.selectedEntityFields.filter(
        (e) =>
          e.properties?.filed_content != "Hide" && e.input_type != "DATA_TABLE"
      );
      this.filterLoading = false;
    },
    openTableConfig() {
      this.configureTableDialog = true;
    },
    handleTableAdd() {
      if (
        !this.entityNotificationBody.body.includes(
          "[[relationalEntityDataTable]]"
        )
      ) {
        this.entityNotificationBody.body =
          this.entityNotificationBody.body +
          "<br> [[relationalEntityDataTable]]";
      }
      this.configureTableDialog = false;
    },
    copyURL(field) {
      navigator.clipboard.writeText(`[[${field}]]`);
      this.$message({
        message: `${field} Field Copied!`,
        type: "success",
      });
    },
    pushToSubject(field) {
      this.entityNotificationBody.subject =
        this.entityNotificationBody.subject + `[[${field}]]`;
      this.$message({
        message: `${field} added to body`,
        type: "success",
      });
    },
    checkFormDisabled() {
      if (!this.form.entity_id || !this.form.selectedFields.length) {
        return true;
      }
      return false;
    },
    // checkSaveAsTemplateDisabled() {
    //   let isValid = this.validateContent();
    //   return isValid.value
    // },
    async prepareDataDebounced() {
      this.emailConfigLoading = true;
      this.loadingText = "Preparing data";
      await this.prepareData();
      if (this.isAutomation) {
        await this.getExistedData();
      }
      this.emailConfigLoading = false;
    },
    getSupportedSubjectFields() {
      let supportedFields = this.allMentionableFields.filter(
        (e) => e.isSubjectSupported
      );
      return supportedFields;
    },
  },
  watch: {
    entityData: {
      handler: function () {
        this.prepareDataDebounced();
      },
      deep: true,
    },

    currentEntity: {
      handler: function () {
        this.prepareDataDebounced();
      },
      deep: true,
    },

    selectedIds: {
      handler: function () {
        this.prepareDataDebounced();
      },
      deep: true,
    },

    isSendIndividual: {
      handler: function () {
        this.prepareDataDebounced();
      },
      deep: true,
    },

    keyValue: {
      handler: function () {
        this.prepareDataDebounced();
      },
      deep: true,
    },
  },
  created() {
    // this.prepareDataDebounced = _.debounce(this.prepareDataDebounced, 300);
    this.prepareDataDebounced = debounce(this.prepareDataDebounced, 300);
  },
};
</script>
<style>
.textDisplay {
  white-space: nowrap;
}
</style>

<style lang="scss" scoped>
.Filters-GroupBy {
  margin-left: 20px;
}
.email-options {
  display: flex;
  align-items: center;
}
.Filters-Container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.Filter-Row {
  display: flex;
  gap: 0.5rem;
}

.Filter-Label {
  font-weight: bold;
}

.Filter-Items {
  display: flex;
  gap: 1rem;
}

.Filter-Item {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.counter-box {
  display: flex;
  align-items: center;
}

.el-select .el-select__tags > span {
  display: flex;
  overflow-x: auto;
}
</style>
<style scoped>
.filter-ai-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  white-space: nowrap;
}

.ai-icon-content {
  display: flex;
  min-width: 115px;
  align-items: center;
  color: var(--primary-color);
  cursor: pointer;
}

.ai-text {
  margin-left: 8px;
  color: var(--primary-color);
  display: inline-block;
}

.try-ai-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}

.el-select-dropdown__item {
  font-size: 14px;
  padding: 8px 20px;
  position: relative;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #606266;
  height: auto;
  line-height: 20px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
  width: 200px;
}

.opt {
  position: relative;
  bottom: 5px;
}

.select-fields {
  position: relative;
  bottom: 0px;
}

.flex-column {
  display: flex;
  flex-direction: column !important;
}
</style>
